import { render, staticRenderFns } from "./CatLogo.vue?vue&type=template&id=4b597b38&"
import script from "./CatLogo.vue?vue&type=script&lang=js&"
export * from "./CatLogo.vue?vue&type=script&lang=js&"
import style0 from "./CatLogo.vue?vue&type=style&index=0&id=4b597b38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports